import React from 'react';
import { TableCell } from '@material-ui/core';
import { ArrowDownIcon, ArrowUpIcon } from '../../icons';

function SortableTableCell({ arrow, children, onClick, align }) {
    return (
        <TableCell style={{ cursor: 'pointer' }} onClick={onClick} align={align}>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: align === 'center' ? 'center' : undefined
                }}
            >
                {children}
                {arrow === 'ASC' && <ArrowUpIcon />}
                {arrow === 'DESC' && <ArrowDownIcon />}
            </div>
        </TableCell>
    );
}

export default SortableTableCell;
